import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import Affiliates from 'pages/affiliates'
import AffiliatesTree from 'pages/affiliates/tree'
import { PAGES } from 'routes/index'

export const affiliatesRoutes: RouteObject[] = [
  {
    path: PAGES.AFFILIATES,
    element: (
      <PrivateRoute feature={FEATURE.AFFILIATE}>
        <Affiliates />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.AFFILIATES_TREE_ADDRESS,
    element: (
      <PrivateRoute feature={FEATURE.AFFILIATE}>
        <AffiliatesTree />
      </PrivateRoute>
    ),
  },
]
